module.exports = __webpack_public_path__ + "media/images/partners/code-club-fa95a87e478798a6bfead5ff2193bcfb.svg";